<template>
  <el-dialog
    title="选择经销商"
    :visible.sync="visible"
    width="800px"
    append-to-body=""
    @closed="handleClosed">
    <div class="search-form">
      <el-input
        v-model="config.dealerName"
        placeholder="请输入经销商名称"
        style="width: 200px"
        clearable=""
        class="input-with-select">
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="handleCurrentChange(1)"></el-button>
      </el-input>
    </div>
    <el-table
      v-loading="loading"
      border
      highlight-current-row
      :data="list"
      @current-change="handleCurrentRowChange">
      <el-table-column
        label=""
        :resizable="false"
        width="30">
        <template slot-scope="{row}">
          <el-radio
            v-model="current.dealerId"
            :label="row.dealerId">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column
        label="经销商名称"
        :resizable="false"
        prop="dealerName"></el-table-column>
      <el-table-column
        label="地址"
        width="240"
        prop="dealerAddress"
        :resizable="false">
      </el-table-column>
      <el-table-column
        label="电话"
        prop="dealerPhone"
        :resizable="false">
      </el-table-column>
      <!-- <el-table-column
        label="发货状态"
        :resizable="false">
      </el-table-column> -->
    </el-table>
    <pagination-new
      v-model="config"
      :total="total"
      :fetch="fetchList" />
    <div slot="footer">
      <el-button @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        @click="add">确 定</el-button>
    </div>
    <!-- <notag-returen-modal ref="notag" /> -->
  </el-dialog>
</template>
<script>
// import NotagReturenModal from './notag-returen-modal.vue'

export default {
  name: 'JxsSelectModal',
  components: { },
  props: {
    callback: Function,
    options: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      vendorId: null,
      agentId: null,
      list: [],
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        dealerName: ''
      },
      total: 0,
      current: {}
    }
  },
  created() { },
  mounted() { },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.list = []
      this.config.pageNum = 1
      this.total = 0
      this.current = {}
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    add() {
      if (!this.current.dealerId) {
        this.$message.error('请选择一个经销商')
        return
      }
      this.upgrade()
      // this.callback && this.callback(this.current.dealerId)
      // this.getoutstockorder(this.current.id)
    },
    upgrade() {
      this.loading = true
      this.$store.dispatch('agent/bindzsdealer', {
        payload: {
          vendorId: this.vendorId,
          agentId: this.agentId,
          zsDealerId: this.current.dealerId
        },
        success: () => {
          this.loading = false
          this.toggleModal(false)
          this.callback && this.callback()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleCurrentRowChange(row) {
      this.current = row || {}
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('agent/getbindablezsdealers', {
        payload: {
          ...this.config,
          ...this.options
        },
        success: res => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(row) {
      this.vendorId = row.vendorId
      this.agentId = row.agentId
      // this.options = options
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
